import { formatCurrency } from "../common/Converter";
import { aggregateUseCase } from "../../usecases/object";

function formatRateForDisplay(monthlyRate) {
  if (monthlyRate == null || monthlyRate === "") return "";
  return formatCurrency(String(monthlyRate));
}

export function getSalaryGradePipeline(salaryCodes) {
  const uniqueCodes = [...new Set((salaryCodes || []).filter(Boolean))];
  if (!uniqueCodes.length) return null;

  return [
    {
      $match: {
        salaryCode: { $in: uniqueCodes },
      },
    },
    {
      $sort: { createdAt: -1 },
    },
    {
      $group: {
        _id: "$salaryCode",
        salaryCode: { $first: "$salaryCode" },
        name: { $first: "$name" },
        Step: { $first: "$Step" },
        "Monthly Rate": { $first: "$Monthly Rate" },
      },
    },
    {
      $project: {
        _id: 0,
        salaryCode: 1,
        name: 1,
        Step: 1,
        "Monthly Rate": 1,
      },
    },
  ];
}

export function formatSalaryGradeRecord(record) {
  if (!record?.name) return "";
  const monthlyRate = record["Monthly Rate"];
  if (monthlyRate == null || monthlyRate === "") {
    return record.name;
  }
  return `${record.name} (₱ ${formatRateForDisplay(monthlyRate)} per month)`;
}

export function formatNonRegSalaryGrade(monthlyRate) {
  if (monthlyRate == null || monthlyRate === "") return "";
  return `(₱ ${formatRateForDisplay(monthlyRate)} per month)`;
}

function getNonRegMonthlyRate(nonRegPosition) {
  if (!nonRegPosition || typeof nonRegPosition !== "object") return null;
  const rate = nonRegPosition.montlhyRate ?? nonRegPosition.monthlyRate;
  return rate == null || rate === "" ? null : rate;
}

export function collectSalaryCodes(objects = []) {
  return objects
    .filter((obj) => !getNonRegMonthlyRate(obj.nonRegPosition) && obj.salaryCode)
    .map((obj) => obj.salaryCode);
}

export async function loadSalaryGradeMap(objects = []) {
  const pipeline = getSalaryGradePipeline(collectSalaryCodes(objects));
  if (!pipeline) return new Map();

  const rows = await aggregateUseCase().execute("salary_grade", pipeline);
  return new Map(
    (rows || [])
      .filter((row) => row?.salaryCode)
      .map((row) => [row.salaryCode, row]),
  );
}

export function resolveSalaryGradeField(obj, salaryGradeMap) {
  const nonRegRate = getNonRegMonthlyRate(obj.nonRegPosition);
  if (nonRegRate != null) {
    return formatNonRegSalaryGrade(nonRegRate);
  }

  if (obj.salaryCode && salaryGradeMap.has(obj.salaryCode)) {
    return formatSalaryGradeRecord(salaryGradeMap.get(obj.salaryCode));
  }

  if (typeof obj.salaryGrade === "string" && obj.salaryGrade.trim()) {
    return obj.salaryGrade;
  }

  return "";
}

export async function resolveSalaryGradesForExport(objects = []) {
  if (!objects.length) return objects;

  const salaryGradeMap = await loadSalaryGradeMap(objects);
  objects.forEach((obj) => {
    obj.salaryGrade = resolveSalaryGradeField(obj, salaryGradeMap);
  });
  return objects;
}
